import moment from 'moment';

export class DateHelper {
  /**
   * targetTimeからtargetTimeまでのdiffを計算する
   * diffの単位はmomentUnitで与えられた単位
   */
  static count(baseTime, targetTime, momentUnit) {
    const baseMoment = moment(baseTime);
    const targetMoment = moment(targetTime);
    return baseMoment.diff(targetMoment, momentUnit);
  }
}
